var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _g, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _g3, _path13, _path14, _g4, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHrk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2441_4029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2441_4029)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2441_4029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2441_4029)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#E31D1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#3D58DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.24255,
    y: 6.13037,
    width: 8.19375,
    height: 3.83333,
    fill: "#E31D1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53203 8.32861H15.0542C15.0708 9.00873 15.0753 10.4663 15.0752 11.8464C15.0752 12.6461 15.0736 13.4159 15.072 13.9858C15.0712 14.2708 15.0705 14.5057 15.0699 14.6694L15.0692 14.8589L15.069 14.9086L15.069 14.911L15.0654 14.9414C15.0617 14.971 15.0557 15.0154 15.0467 15.0727C15.0287 15.1872 14.9989 15.3524 14.952 15.5512C14.8578 15.9501 14.696 16.4782 14.4263 17.0033C13.8886 18.0501 12.9424 19.0557 11.2484 19.0557C9.55746 19.0557 8.6515 18.0516 8.15276 17.0061C7.90223 16.4809 7.75945 15.9523 7.67954 15.5528C7.63972 15.3537 7.61583 15.1883 7.60196 15.0736C7.59503 15.0163 7.59062 14.9717 7.58797 14.9421L7.58524 14.9091L7.58504 14.9064L7.58497 14.898L7.58452 14.8486L7.58281 14.6605L7.5767 13.9814C7.57165 13.4151 7.56492 12.6497 7.55818 11.8532C7.54662 10.4856 7.53507 9.02822 7.53203 8.32861Z",
    fill: "#F7FCFF",
    stroke: "#E31D1C",
    strokeWidth: 0.5625
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2441_4029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 9,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53203 8.32861H15.0542C15.0708 9.00873 15.0753 10.4663 15.0752 11.8464C15.0752 12.6461 15.0736 13.4159 15.072 13.9858C15.0712 14.2708 15.0705 14.5057 15.0699 14.6694L15.0692 14.8589L15.069 14.9086L15.069 14.911L15.0654 14.9414C15.0617 14.971 15.0557 15.0154 15.0467 15.0727C15.0287 15.1872 14.9989 15.3524 14.952 15.5512C14.8578 15.9501 14.696 16.4782 14.4263 17.0033C13.8886 18.0501 12.9424 19.0557 11.2484 19.0557C9.55746 19.0557 8.6515 18.0516 8.15276 17.0061C7.90223 16.4809 7.75945 15.9523 7.67954 15.5528C7.63972 15.3537 7.61583 15.1883 7.60196 15.0736C7.59503 15.0163 7.59062 14.9717 7.58797 14.9421L7.58524 14.9091L7.58504 14.9064L7.58497 14.898L7.58452 14.8486L7.58281 14.6605L7.5767 13.9814C7.57165 13.4151 7.56492 12.6497 7.55818 11.8532C7.54662 10.4856 7.53507 9.02822 7.53203 8.32861Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5625
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2441_4029)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54578 8.66309H9.06189V10.7157H7.54578V8.66309ZM9.06189 10.7157H10.578V12.7684H9.06189V10.7157ZM12.0941 12.7684H10.578V14.8211H9.06189V16.8737H10.578V18.9264H12.0941V16.8737H13.6102V18.9264H15.1263V16.8737H13.6102V14.8211H15.1263V12.7684H13.6102V10.7157H15.1263V8.66309H13.6102V10.7157H12.0941V8.66309H10.578V10.7157H12.0941V12.7684ZM12.0941 14.8211H13.6102V12.7684H12.0941V14.8211ZM12.0941 14.8211V16.8737H10.578V14.8211H12.0941ZM7.54578 12.7684H9.06189V14.8211H7.54578V12.7684ZM9.06189 16.8737H7.54578V18.9264H9.06189V16.8737Z",
    fill: "#F50100"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51316 7.82218C7.51316 7.82218 7.98209 7.4882 8.38206 7.31609C8.78204 7.14397 9.09817 7.04993 9.09817 7.04993L8.50309 4.12501L7.31117 3.53125L6.63611 5.01485L7.51316 7.82218Z",
    fill: "#56C6F5",
    stroke: "white",
    strokeWidth: 0.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4512 6.78076C10.4512 6.78076 10.8511 6.73317 11.2713 6.74406C11.6915 6.75495 12.047 6.75893 12.047 6.75893L12.2523 3.87484L11.3522 2.7906L10.3516 3.90033L10.4512 6.78076Z",
    fill: "#56C6F5",
    stroke: "white",
    strokeWidth: 0.15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99199 7.00175L9.0114 7.08968L9.09437 7.05469L9.09438 7.05468L9.09442 7.05466L9.09464 7.05457L9.09558 7.05418L9.09938 7.05259L9.11428 7.04642C9.1273 7.04105 9.14628 7.0333 9.16996 7.02382C9.21733 7.00486 9.28337 6.97905 9.358 6.95166C9.50864 6.89636 9.68935 6.83647 9.8223 6.81184C9.95842 6.78662 10.1267 6.76837 10.2623 6.75641C10.3299 6.75045 10.3888 6.7461 10.4307 6.74323L10.4799 6.74004L10.493 6.73927L10.4964 6.73908L10.4972 6.73903L10.4974 6.73902L10.4974 6.73902L10.4974 6.73902L10.4974 6.73902L10.5731 6.73487L10.5682 6.65929L10.3868 3.85672L10.3849 3.82735L10.3636 3.80711L9.38411 2.87962L9.32195 2.82076L9.27177 2.89012L8.38162 4.12054L8.36189 4.14781L8.36915 4.18067L8.99199 7.00175Z",
    fill: "#2E42A5",
    stroke: "white",
    strokeWidth: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2441_4029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 3,
    height: 6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99199 7.00175L9.0114 7.08968L9.09437 7.05469L9.09438 7.05468L9.09442 7.05466L9.09464 7.05457L9.09558 7.05418L9.09938 7.05259L9.11428 7.04642C9.1273 7.04105 9.14628 7.0333 9.16996 7.02382C9.21733 7.00486 9.28337 6.97905 9.358 6.95166C9.50864 6.89636 9.68935 6.83647 9.8223 6.81184C9.95842 6.78662 10.1267 6.76837 10.2623 6.75641C10.3299 6.75045 10.3888 6.7461 10.4307 6.74323L10.4799 6.74004L10.493 6.73927L10.4964 6.73908L10.4972 6.73903L10.4974 6.73902L10.4974 6.73902L10.4974 6.73902L10.4974 6.73902L10.5731 6.73487L10.5682 6.65929L10.3868 3.85672L10.3849 3.82735L10.3636 3.80711L9.38411 2.87962L9.32195 2.82076L9.27177 2.89012L8.38162 4.12054L8.36189 4.14781L8.36915 4.18067L8.99199 7.00175Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2441_4029)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5826 7.00046L13.5644 7.09032L13.4799 7.05469L13.4799 7.05468L13.4799 7.05466L13.4797 7.05457L13.4787 7.05418L13.4749 7.05259L13.46 7.04642C13.447 7.04105 13.428 7.0333 13.4044 7.02382C13.357 7.00486 13.2909 6.97905 13.2163 6.95166C13.0657 6.89636 12.885 6.83647 12.752 6.81184C12.6159 6.78662 12.4476 6.76837 12.312 6.75641C12.2444 6.75045 12.1856 6.7461 12.1436 6.74323L12.0944 6.74004L12.0813 6.73927L12.078 6.73908L12.0771 6.73903L12.0769 6.73902L12.0769 6.73902L12.0769 6.73902L12.0769 6.73902L12.0013 6.73487L12.0062 6.65929L12.1875 3.85672L12.1894 3.82735L12.2107 3.80711L13.1902 2.87962L13.254 2.8192L13.3037 2.89171L14.1429 4.11748L14.1609 4.14365L14.1546 4.17473L13.5826 7.00046Z",
    fill: "#2E42A5",
    stroke: "white",
    strokeWidth: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2441_4029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 2,
    width: 4,
    height: 6
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5826 7.00046L13.5644 7.09032L13.4799 7.05469L13.4799 7.05468L13.4799 7.05466L13.4797 7.05457L13.4787 7.05418L13.4749 7.05259L13.46 7.04642C13.447 7.04105 13.428 7.0333 13.4044 7.02382C13.357 7.00486 13.2909 6.97905 13.2163 6.95166C13.0657 6.89636 12.885 6.83647 12.752 6.81184C12.6159 6.78662 12.4476 6.76837 12.312 6.75641C12.2444 6.75045 12.1856 6.7461 12.1436 6.74323L12.0944 6.74004L12.0813 6.73927L12.078 6.73908L12.0771 6.73903L12.0769 6.73902L12.0769 6.73902L12.0769 6.73902L12.0769 6.73902L12.0013 6.73487L12.0062 6.65929L12.1875 3.85672L12.1894 3.82735L12.2107 3.80711L13.1902 2.87962L13.254 2.8192L13.3037 2.89171L14.1429 4.11748L14.1609 4.14365L14.1546 4.17473L13.5826 7.00046Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2441_4029)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2221 7.8695L15.2537 7.77236L16.1437 5.03806L16.1527 5.01033L16.1407 4.98378L15.4656 3.50019L15.4334 3.42948L15.3639 3.46412L14.172 4.05788L14.1396 4.074L14.1321 4.10937L13.524 6.96127L13.5095 7.02904L15.2221 7.8695ZM15.2221 7.8695L15.1389 7.81024M15.2221 7.8695L15.1389 7.81024M15.1389 7.81024L15.1389 7.81024M15.1389 7.81024L15.1389 7.81024M15.1389 7.81024L15.1388 7.8102L15.1386 7.81005L15.1377 7.80938L15.1338 7.80667L15.1186 7.79602C15.1052 7.78672 15.0856 7.77318 15.0608 7.75638C15.0111 7.72276 14.9408 7.67612 14.858 7.62416C14.6919 7.51984 14.4785 7.39572 14.2838 7.31195C14.0858 7.22674 13.9085 7.16083 13.7807 7.11625C13.7168 7.09397 13.6654 7.07704 13.6301 7.06571L13.5896 7.05295L13.5793 7.04978L13.5767 7.04901L13.5761 7.04883L13.576 7.0488L13.576 7.04879L13.576 7.04879L15.1389 7.81024Z",
    fill: "#56C6F5",
    stroke: "white",
    strokeWidth: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2441_4029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 3,
    width: 4,
    height: 5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2221 7.8695L15.2537 7.77236L16.1437 5.03806L16.1527 5.01033L16.1407 4.98378L15.4656 3.50019L15.4334 3.42948L15.3639 3.46412L14.172 4.05788L14.1396 4.074L14.1321 4.10937L13.524 6.96127L13.5095 7.02904L15.2221 7.8695ZM15.2221 7.8695L15.1389 7.81024M15.2221 7.8695L15.1389 7.81024M15.1389 7.81024L15.1389 7.81024M15.1389 7.81024L15.1389 7.81024M15.1389 7.81024L15.1388 7.8102L15.1386 7.81005L15.1377 7.80938L15.1338 7.80667L15.1186 7.79602C15.1052 7.78672 15.0856 7.77318 15.0608 7.75638C15.0111 7.72276 14.9408 7.67612 14.858 7.62416C14.6919 7.51984 14.4785 7.39572 14.2838 7.31195C14.0858 7.22674 13.9085 7.16083 13.7807 7.11625C13.7168 7.09397 13.6654 7.07704 13.6301 7.06571L13.5896 7.05295L13.5793 7.04978L13.5767 7.04901L13.5761 7.04883L13.576 7.0488L13.576 7.04879L13.576 7.04879L15.1389 7.81024Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2441_4029)"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2441_4029)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2441_4029",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrk);
export default __webpack_public_path__ + "static/media/HRK.70c638ec47aab31ba4fe105af44aa122.svg";
export { ForwardRef as ReactComponent };